import { useCallback, useState } from 'react';
import { usePermissionsContext } from '../context/PermissionsContext';
import Toast from '../components/Utils/Toast';

export const usePermissions = () => {
  const { hasPermission } = usePermissionsContext();
  const [showToast, setShowToast] = useState(false);

  const checkPermission = useCallback((permissionKey, showError = true) => {
    const hasPerm = hasPermission(permissionKey);
    if (!hasPerm && showError) {
      setShowToast(true);
    }
    return hasPerm;
  }, [hasPermission]);

  const ToastComponent = () => (
    <Toast
      show={showToast}
      message="Você não possui permissão para acessar esse recurso!"
      onClose={() => setShowToast(false)}
    />
  );

  return {
    hasPermission,
    checkPermission,
    ToastComponent,
  };
};

